export const Separator = ({ text, textColor }) => {
    return (
        <div className="flex items-center justify-center !my-5">
            <hr className="flex-grow border-t border-gray-300" />
            <span className={`mx-4 ${textColor ? `text-${textColor}` : "text-gray-500"}`}>{text}</span>
            <hr className="flex-grow border-t border-gray-300" />
        </div>
    );
};
